// AppThemeProvider.jsx
import React, { useMemo, useEffect } from 'react';
import { ThemeProvider, CssBaseline, GlobalStyles } from '@mui/material';
import { useSelector } from 'react-redux';
import { createAppTheme } from './theme';

export default function AppThemeProvider({ children }) {
  // get both the default and active (dynamic) theme from Redux
  const defaultTheme = useSelector((state) => state?.theme?.default_theme);
  const rawTheme = useSelector((s) => s?.theme?.theme);
  const dynamicTheme = Array.isArray(rawTheme) ? rawTheme[0] : rawTheme;

  const activeTheme = dynamicTheme || defaultTheme;


  const theme = useMemo(
    () => createAppTheme(dynamicTheme),
    [dynamicTheme]
  );

  useEffect(() => {
    const root = document.documentElement;
    const onPrimary = theme.palette.getContrastText(theme.palette.primary.main);

    root.style.setProperty('--primary-color', theme.palette.primary.main);
    root.style.setProperty('--primary-contrast', onPrimary);
    root.style.setProperty('--secondary-color', theme.palette.secondary.main);
    root.style.setProperty('--app-font', theme.typography.fontFamily);
  }, [theme]);
  // optional: prevent rendering before theme is ready
  if (!activeTheme) {
    return <div style={{ textAlign: 'center', padding: '40px' }}>Loading theme…</div>;
  }



  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles
        styles={{
          /* Header: background = PRIMARY, text = SECONDARY */
          '.header-container': {
            backgroundColor: 'var(--primary-color)',
            color: 'var(--secondary-color)',
            fontFamily: 'var(--app-font)',
          },

          '.header-container .MuiTypography-root, \
           .header-container .MuiButton-root, \
           .header-container .MuiIconButton-root, \
           .header-container .MuiSvgIcon-root, \
           .header-container a': {
            color: 'inherit',
          },
        }}
      />
      {children}
    </ThemeProvider>
  );
}
